import { useState } from "react";
import { Menu, Modal, Checkbox, Button, Row, Col } from "antd";

import { industryType, isEnvVarEquals } from "utils/helpers";

import { ClientType } from "shared/types/adLibrary";

import { IndustryType } from "shared/types/shared";
import {
  basicColumns,
  industrySpecificColumns,
  sharedColumns,
} from "screens/adLibrary/library/adList/shared/columns";
interface Props {
  displayColumn: boolean;
  selectedColumns: string[];
  setSelectedColumns: (data: string[]) => void;
  setDisplayColumn: (displayColumn: boolean) => void;
  columnNames: string[];
  clientType: IndustryType;
  setClientType: (clientType: IndustryType) => void;
}

const ColumnsFilter = ({
  displayColumn,
  selectedColumns,
  setSelectedColumns,
  setDisplayColumn,
  columnNames,
  clientType,
  setClientType,
}: Props) => {
  const [tempColumns, setTempColumns] = useState<string[]>(selectedColumns);

  const [tempClientType, setTempClientType] =
    useState<IndustryType>(clientType);

  const industryColumnTitle =
    tempClientType === "all"
      ? columnNames.map(name => name)
      : columnNames.filter(
          name =>
            sharedColumns.includes(name) ||
            industrySpecificColumns[tempClientType].includes(name),
        );

  return (
    <Modal
      className="ad-table-column-modal"
      title="Show / Hide Columns"
      width="500px"
      onCancel={() => {
        setDisplayColumn(false);
        setTempColumns(selectedColumns);
      }}
      visible={displayColumn}
      footer={
        <div>
          <Checkbox
            key="selectAll"
            checked={industryColumnTitle.every(c => tempColumns.includes(c))}
            onClick={() => {
              if (industryColumnTitle.every(c => tempColumns.includes(c))) {
                setTempColumns(basicColumns);
              } else {
                setTempColumns(industryColumnTitle);
              }
            }}
          >
            Select All
          </Checkbox>
          <Button
            key="ok"
            onClick={() => {
              setSelectedColumns(
                industryColumnTitle.filter(t => tempColumns.includes(t)),
              );
              setClientType(tempClientType);
              setDisplayColumn(false);
            }}
          >
            OK
          </Button>
        </div>
      }
    >
      {industryType("auto") && isEnvVarEquals("CLIENT", "internal") && (
        <Menu
          defaultSelectedKeys={[clientType]}
          onClick={({ key }) => {
            setTempClientType(key as IndustryType);
          }}
        >
          {Object.entries(ClientType).map(([key, value]) => {
            return <Menu.Item key={key}>{value}</Menu.Item>;
          })}
        </Menu>
      )}
      <Checkbox.Group
        defaultValue={selectedColumns}
        value={tempColumns}
        onChange={newColumns => setTempColumns(newColumns as string[])}
      >
        <Row justify="space-around" align="top">
          <Col span={11}>
            {industryColumnTitle
              .slice(0, (industryColumnTitle.length + 1) / 2)
              .map(title => (
                <Checkbox
                  key={title}
                  value={title}
                  disabled={basicColumns.includes(title)}
                >
                  {title}
                </Checkbox>
              ))}
          </Col>
          <Col span={11}>
            {industryColumnTitle
              .slice((industryColumnTitle.length + 1) / 2)
              .map(title => (
                <Checkbox key={title} value={title}>
                  {title}
                </Checkbox>
              ))}
          </Col>
        </Row>
      </Checkbox.Group>
    </Modal>
  );
};

export default ColumnsFilter;
